import React from "react";
import styled from "styled-components";
import { COLOR_SYSTEM } from "components/design/design-system";
import Text from "components/atoms/Text";
import CommonHeader from "components/organisms/CommonHeader";
import YmydSignupForm from "components/organisms/YmydSignupForm";

interface YmydSignupTemplateProps {
  formData: {
    email: string;
    password: string;
    passwordConfirm: string;
    name: string;
    phone: string;
    company: string;
    license?: string;
  };
  passwordError?: string | null;
  passwordConfirmError?: string | null;
  onPasswordChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onPasswordConfirmChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onSubmit: (e: React.FormEvent) => void;
  onCancel: () => void;
}

const Container = styled.div`
  min-height: 100vh;
  background-color: ${COLOR_SYSTEM.get("Gray")[0]};
  display: flex;
  flex-direction: column;
`;

const Main = styled.main`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
`;

const FormWrapper = styled.div`
  width: 100%;
  max-width: 520px;
`;

const FormContainer = styled.div`
  background-color: ${COLOR_SYSTEM.get("Gray")[0]};
  border-radius: 1rem;
  border: 1px solid ${COLOR_SYSTEM.get("Gray")[200]};
  padding: 3rem 2.5rem 2.5rem 2.5rem;
  box-shadow: 0 2px 16px rgba(0, 0, 0, 0.04);
`;

const Header = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin-bottom: 2rem;
  gap: 0.5rem;
`;

const YmydBadge = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: #FEE500;
  color: #000000;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 1.5rem;
`;

const Logo = styled.img`
  height: 32px;
  margin-bottom: 0.5rem;
`;

const YmydSignupTemplate: React.FC<YmydSignupTemplateProps> = ({
  formData,
  passwordError,
  passwordConfirmError,
  onPasswordChange,
  onPasswordConfirmChange,
  onSubmit,
  onCancel,
}) => {
  return (
    <Container>
      <CommonHeader withoutPath={true} />
      <Main>
        <FormWrapper>
          <FormContainer>
            <Header>
              <Logo src="/images/logo.png" alt="약문약답 로고" />
              <Text textType="H2" color={COLOR_SYSTEM.get("Gray")[800]} style={{ marginBottom: "1rem" }}>
                회원가입
              </Text>
              <YmydBadge>
                약문약답 약사인증 완료
              </YmydBadge>
              <Text textType="Body2" color={COLOR_SYSTEM.get("Gray")[600]} style={{ marginTop: "0.5rem" }}>
                약문약답에 입력되었던 계정 정보로 기본 정보를 채워두었습니다.<br />
                이메일 주소가 정확한지 확인하시고, PhAI 비밀번호를 설정해주세요.
              </Text>
            </Header>
            <YmydSignupForm
              formData={formData}
              passwordError={passwordError}
              passwordConfirmError={passwordConfirmError}
              onPasswordChange={onPasswordChange}
              onPasswordConfirmChange={onPasswordConfirmChange}
              onSubmit={onSubmit}
              onCancel={onCancel}
            />
          </FormContainer>
        </FormWrapper>
      </Main>
    </Container>
  );
};

export default YmydSignupTemplate;